export enum PageType{
    About = 1, //hakkımızda
    //PoliciesKvkk = 2, //gizlilik politikası ve kvkk
    FrequentlyAskedQuestions = 3, //sık sorulan sorular
    Blog = 4,
    TermsAndConditions = 5,
    ClarificationText = 6,
    InformationTextRegardingTheProcessingOfPersonalData = 7,
    CookiePolicy = 8 , 
    CancellationAndRefund = 9 

}